import PeriodSummary from './PeriodSummary.vue';

export default PeriodSummary;


// WEBPACK FOOTER //
// ./src/components/PeriodSummary/index.js